/**
 * <code>UIEvent</code> 类用来定义UI组件类的事件类型。
 */
export class UIEvent {
    /**
     * 显示提示信息。
     */
    static SHOW_TIP: string = "showtip";
    /**
     * 隐藏提示信息。
     */
    static HIDE_TIP: string = "hidetip";
}